var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns10,"data":_vm.data9}}),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","overflow":"hidden"}},[_c('div',{staticStyle:{"float":"right"}},[_c('Page',{attrs:{"total":_vm.total,"page-size":30,"current":_vm.current},on:{"on-change":_vm.changePage}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }